import { render, staticRenderFns } from "./StaffSingleCheckups.vue?vue&type=template&id=41e86063&"
import script from "./StaffSingleCheckups.vue?vue&type=script&lang=js&"
export * from "./StaffSingleCheckups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports